import { render, staticRenderFns } from "./carbonEmission.vue?vue&type=template&id=27dcf650&scoped=true&"
import script from "./carbonEmission.vue?vue&type=script&lang=js&"
export * from "./carbonEmission.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27dcf650",
  null
  
)

export default component.exports